import { LISTACCOUNTPROFILE, RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  FETCH_TERM_DEPOSIT_LIST_TOP_UP_REQUEST,
  FETCH_TERM_DEPOSIT_LIST_TOP_UP_SUCCESS,
  FETCH_TERM_DEPOSIT_LIST_TOP_UP_FAILURE,
  FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_FAILURE,
  FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_FAILURE,
  FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_SUCCESS,
  FETCH_TERM_DEPOSIT_TOP_UP_CREATE_FAILURE,
  FETCH_TERM_DEPOSIT_TOP_UP_CREATE_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_CREATE_SUCCESS,
  SET_TERM_TOP_UP_STORE,
  SET_TERM_TOP_UP_RESET,
} from "./actions.type";
import {
  FetchTermDepositListTopUpRequest,
  FetchTermDepositListTopUpSuccess,
  FetchTermDepositListTopUpFailure,
  FetchTermDepositTopUpCreateRequest,
  FetchTermDepositTopUpCreateSuccess,
  FetchTermDepositTopUpCreateFailure,
  FetchTermDepositTopUpConfirmRequest,
  FetchTermDepositTopUpConfirmSuccess,
  FetchTermDepositTopUpConfirmFailure,
  FetchTermDepositTopUpAuthorizationRequest,
  FetchTermDepositTopUpAuthorizationSuccess,
  FetchTermDepositTopUpAuthorizationFailure,
  SetTermTopUpStore,
  SetTermTopUpReset,
  DataTermDepositTopUp,
  TermDepositTopUpState,
} from "./types";

export const fetchTermDepositListTopUpRequest = (payload?: string): FetchTermDepositListTopUpRequest => ({
  type: FETCH_TERM_DEPOSIT_LIST_TOP_UP_REQUEST,
  payload,
});

export const fetchTermDepositListTopUpSuccess = (payload?: LISTACCOUNTPROFILE): FetchTermDepositListTopUpSuccess => ({
  type: FETCH_TERM_DEPOSIT_LIST_TOP_UP_SUCCESS,
  payload,
});

export const fetchTermDepositListTopUpFailure = (payload?: string): FetchTermDepositListTopUpFailure => ({
  type: FETCH_TERM_DEPOSIT_LIST_TOP_UP_FAILURE,
  payload,
});

export const fetchTermDepositTopUpCreateRequest = (payload?: DataTermDepositTopUp): FetchTermDepositTopUpCreateRequest => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_CREATE_REQUEST,
  payload,
});

export const fetchTermDepositTopUpCreateSuccess = (payload?: RESPONSEDATA): FetchTermDepositTopUpCreateSuccess => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_CREATE_SUCCESS,
  payload,
});

export const fetchTermDepositTopUpCreateFailure = (payload?: string): FetchTermDepositTopUpCreateFailure => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_CREATE_FAILURE,
  payload,
});

export const fetchTermDepositTopUpConfirmRequest = (payload?: RESPONSEDATA): FetchTermDepositTopUpConfirmRequest => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_REQUEST,
  payload,
});

export const fetchTermDepositTopUpConfirmSuccess = (payload?: RESPONSEDATA): FetchTermDepositTopUpConfirmSuccess => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_SUCCESS,
  payload,
});

export const fetchTermDepositTopUpConfirmFailure = (payload?: string): FetchTermDepositTopUpConfirmFailure => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_FAILURE,
  payload,
});

export const fetchTermDepositTopUpAuthorizationRequest = (
  payload?: RESPONSEDATA,
  code?: string,
): FetchTermDepositTopUpAuthorizationRequest => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTermDepositTopUpAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTermDepositTopUpAuthorizationSuccess => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTermDepositTopUpAuthorizationFailure = (payload?: boolean, msg?: string): FetchTermDepositTopUpAuthorizationFailure => ({
  type: FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_FAILURE,
  payload,
  msg,
});

export const setTermTopUpStore = (payload: TermDepositTopUpState): SetTermTopUpStore => ({
  type: SET_TERM_TOP_UP_STORE,
  payload,
});

export const setTermTopUpReset = (): SetTermTopUpReset => ({
  type: SET_TERM_TOP_UP_RESET,
});
